var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _vm.rm
      ? _c("div", { staticClass: "container" }, [
          _vm.IsDownloading
            ? _c("div", [
                _c("h1", [_vm._v("Downloading template...")]),
                _vm._v(" "),
                _c("h3", [
                  _vm._v(
                    "Depending on the project's size it may take from a few seconds to a few minutes."
                  ),
                ]),
              ])
            : _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-8 col-md-10 col-sm-12" }, [
                  _c("h3", { staticClass: "my-5" }, [
                    _vm._v("Please select a workspace to download a template:"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "table",
                    { staticClass: "table table-bordered table-hover" },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.rm.Workspaces, function (w) {
                          return _c("tr", { key: w.Id }, [
                            _c("td", [_vm._v(_vm._s(w.Name))]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary text-white",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleDownloadProjectTemplateCommand(
                                        w.Id
                                      )
                                    },
                                  },
                                },
                                [_vm._v("Download")]
                              ),
                            ]),
                          ])
                        }),
                        0
                      ),
                    ]
                  ),
                ]),
              ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Workspace")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "100px" } }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }